module.exports = {
  fallback: {
    title: 'Error',
    subTitle: 'Service not available',
    message: 'Unfortunately, your request could not be processed. Please try again later.',
  },
  notFound: {
    title: 'Page not found',
    subTitle: "",
    message: 'Unfortunately, the page you were looking for could not be found.',
  },
  clientError: {
    title: 'Do you need help?',
    subTitle: "",
    message: 'An error was detected. If this message is displayed more often, please contact the site operator...',
  },
  unknownPageTitle: 'Unknown page',
}